module.exports = __webpack_public_path__ + "img/check.0ddcef01.svg";